<template>
  <div>
    <v-btn icon small @click.stop="dialog = true"
      v-if="this.getCommsGlobal.basic.act === true">
      <v-icon :color="ui.colorWarning"> build </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          {{this.getCommsGlobal.basic.title}}
        </v-card-title>
        <v-card-text>
          <v-layout row :class="ui.textSubheadingBold">
            <v-flex xs12>
              {{this.getCommsGlobal.char.com1}}
            </v-flex>
          </v-layout>
          <div class="mt-3"/>
          <v-layout row :class="ui.textSubheadingBold">
            <v-flex xs12>
              {{this.getCommsGlobal.char.com2}}
            </v-flex>
          </v-layout>
          <div class="mt-3"/>
          <v-layout row :class="ui.textSubheadingBold">
            <v-flex xs12>
              {{this.getCommsGlobal.char.com3}}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn :color="ui.btnColor" flat @click="dialog = false">
            <v-icon left> exit_to_app </v-icon>
            back
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
// eslint-disable-next-line
export default {
  data() {
    return {
      dialog: false
    };
  },
  mixins: [apptheme],
  computed: {
    ...mapGetters(["getCommsGlobal", "getUser"])
  }
};
</script>
